/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.0
* 
*******************************************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { PropTypes as T } from 'prop-types';
import { withFocus } from '@accedo/vdkweb-navigation';
import buttonTheme from './focusButton.scss';

// eslint-disable-next-line valid-jsdoc
/**
 * Focus Button is an HTML5 button wrapped inside a `<div>` element. This set up
 * allows the Focus Button not only handle traditional mouse click, but also
 * provides spatial navigation, an essential functionality for application on CTV.
 *
 * @returns {React.ReactElement} The FocusButton Element
 */
export var FocusButton = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FocusButton, _React$PureComponent);
  var _super = _createSuper(FocusButton);
  function FocusButton() {
    var _this;
    _classCallCheck(this, FocusButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getRef", function (c) {
      // eslint-disable-next-line react/no-unused-class-component-methods
      _this.clickNode = c;
    });
    return _this;
  }
  _createClass(FocusButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        theme = _this$props.theme,
        nav = _this$props.nav,
        style = _this$props.style,
        className = _this$props.className,
        onClick = _this$props.onClick,
        children = _this$props.children,
        isActive = _this$props.isActive;
      var _buttonTheme$theme = _objectSpread(_objectSpread({}, buttonTheme), theme),
        buttonContainer = _buttonTheme$theme.buttonContainer,
        button = _buttonTheme$theme.button,
        buttonFocused = _buttonTheme$theme.buttonFocused,
        buttonActive = _buttonTheme$theme.buttonActive;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(buttonContainer, " ").concat(className),
        style: style
      }, /*#__PURE__*/React.createElement("button", {
        ref: this.getRef,
        className: "\n            ".concat(button, " ").concat(isActive ? buttonActive : '', "\n            ").concat(nav.isFocused ? buttonFocused : '', "\n          "),
        onClick: onClick,
        onMouseOut: nav.onMouseOut,
        onMouseOver: nav.onMouseOver
      }, children));
    }
  }]);
  return FocusButton;
}(React.PureComponent);
FocusButton.propTypes = {
  /** React's special prop, children. */
  children: T.node,
  /** Class name that will be applied to the `<div>` element. */
  className: T.string,
  /** whether the button should include the buttonActive class (default style is included in the component for it) */
  isActive: T.bool,
  /** Navigation property, see `@accedo/vdkweb-navigation` */
  nav: T.object,
  /** React onClick event handler function, which will be added to the `<button>` element within the Focus Button. */
  onClick: T.func,
  /** React style attribute object, which will be applied to the `<div>` element. */
  style: T.object,
  /** Styles to override the default theme (CSS class names: buttonContainer, button, buttonFocused, buttonActive) */
  theme: T.object
};
FocusButton.defaultProps = {
  className: '',
  nav: {},
  style: {},
  theme: {}
};
export default withFocus(FocusButton);